import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { showNotification } from 'src/app/helpers/show-toast';
import { CloseProblemModalComponent } from '../../appointments/components/close-problem-modal/close-problem-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AddProplemModalComponent } from '../../appointments/components/add-proplem-modal/add-proplem-modal.component';
import { ReactiveModalComponent } from '../../appointments/components/reactive-modal/reactive-modal.component';
import { RefundModalComponent } from '../../appointments/components/refund-modal/refund-modal.component';
import { AppointmentDetailsComponent } from '../../appointments/components/appointment-details/appointment-details.component';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AllSpecialitiesApi } from 'src/app/_services/allSpecialities.service';
import { AllAppointmentsapi } from 'src/app/_services/allappointments.service';
import { ISmartTableMessage } from 'src/app/_interfaces/smart-table/i-message';
import { TableColumn } from '@swimlane/ngx-datatable';
import { AllAppointmentsData } from 'src/app/_models/all-appointments.model';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-my-journey-beyond-weight',
  templateUrl: './my-journey-beyond-weight.component.html',
  styleUrls: ['./my-journey-beyond-weight.component.scss']
})
export class MyJourneyBeyondWeightComponent implements OnInit {

  pageTitle: string = 'My Journey Beyond Weight';
    allAppointmentsArray: AllAppointmentsData[] = [];
    specialityDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: true,
    };
    statusDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'state',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false,
      enableCheckAll: true,
    };
    statusList = [
      { id: 1, state: 'Pending' },
      { id: 2, state: 'Finished' },
      { id: 3, state: 'Cancelled' },
      { id: 4, state: 'Not Completed' },
      { id: 5, state: 'History' },
      { id: 0, state: 'All' },
      { id: 7, state: 'Ready To Join' },
      { id: 8, state: 'Active' },
      { id: 9, state: 'Patient No Show'},
      { id: 10, state: 'Doctor No Show'},
      { id: 11, state: 'Received Passcode'}
    ];
    specialityList = [];
    selectAllSpecialties = false;
    selectAllStatues = false;
    specialtiesIds: string = '0';
    statusIds: string = '0';
    currentDate: Date = new Date();
    maxDate: Date = new Date();
    params = {};
    appointmentsForm: FormGroup;
    isSubmited: boolean = false;
    modalRef: BsModalRef;
   selectedTab: string = 'All';
  activeStatusId: string = '0';
  searchTimeout: any;

    currentPage: number = 1;
    pageSize: number = 10;
    totalPages: number;
    totalItems: number;
    exportedAppointments: AllAppointmentsData[] = [];
    columns: TableColumn[];
    messages: ISmartTableMessage = {
      emptyMessage: 'Hmm, There are no appointments 🥳',
      totalMessage: 'total',
      selectedMessage: ''
    }
    @ViewChild('patientNameRef') public patientNameRef: TemplateRef<any>;
    @ViewChild('displayNameRef') public displayNameRef: TemplateRef<any>;
    @ViewChild('actionRef') public actionRef: TemplateRef<any>;
  
    constructor(
      private _AllAppoint: AllAppointmentsapi,
      private specialityService: AllSpecialitiesApi,
      public toastr: ToastrService,
      private modalService: BsModalService,
      private _formBuilder: FormBuilder,
      private datePipe: DatePipe
    ) {
      this.currentDate = null;
      this.maxDate= null;
      
    this.activeStatusId = '0';

      this.params = {
        programId:19,
        statusIds: '1,2,3,4,5,6,7,8,9,10,11',
        FromDate: this.currentDate?.toISOString() || null,
        ToDate: this.maxDate?.toISOString() || null,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
    }
  
    ngOnInit(): void {
      this.appointmentsForm = this._formBuilder.group({
      search: [null],
      appointmentDuration: [null], // start empty
    });

    this.activeStatusId = '0';
  this.selectedTab = 'All';
  
      this.getAllAppointments(this.params);
    }


    fetchAppointments(params) {
  const cleanParams = { ...params };
  if (!cleanParams.FromDate) delete cleanParams.FromDate;
  if (!cleanParams.ToDate) delete cleanParams.ToDate;
  
  return this._AllAppoint.getAllMounjaroAppointments(cleanParams);
}
  
    getAllAppointments(params) {
      this.fetchAppointments(params).subscribe((res) => {
    this.allAppointmentsArray = res?.data.items || [];
  
        
          this.columns = [
            { prop: 'patientId', name: 'Patient Id', width: 200 },
            { prop: 'patientName', name: 'Patient Name',  width: 200 },
            { prop: 'patientPhone', name: 'Patient Phone', width: 200 },
            { prop: 'pspCode', name: 'Psp Code', width: 200 },
            {
              prop: 'doctorName', name: 'Doctor Name', width: 200,
              pipe: { transform: (val) => val }
            },
            {
              prop: 'appointmentTime', name: 'Appointment Time', width: 200,
              pipe: { transform: (val) => this.datePipe.transform(val, "MMM d, y, h:mm a") }
            },
            { prop: 'statusId', name: 'Status', pipe: { transform: (val) => this.getStatusName(val) },width:200 },
            { prop: 'callDuration', name: 'Call Duration', width: 200,
              pipe: {transform: (val)=> val}
             },
             { prop: 'endBy', name: 'Ended By', width: 200,
              pipe: {transform: (val)=> val}
             },
            {
              prop: 'isHavePrescription', name: 'Has prescription', width: 200,
              pipe: { transform: (val) => val ? "🟢 YES" : "🔴 NO" }
            },
          ];
        
  
        this.currentPage = res?.data?.pagination.currentPage;
        this.totalPages = res?.data?.pagination.totalPages;
        this.totalItems = res?.data?.pagination.totalItems;
      });
    }
  
    onChangePage(pageDetails: ISmartTablePagination) {
      this.params['pageSize'] = this.pageSize;
      this.currentPage = pageDetails.offset + 1;
      this.params['currentPage'] = this.currentPage;
  
      this.getAllAppointments(this.params);
    }

    
  
    onSearchAppointment(statusId) {
      this.allAppointmentsArray = [];
      this.currentPage = 1;
  
      this.activeStatusId = statusId;

      this.selectedTab = this.statusList.find((status) => {
        return status.id == parseInt(statusId);
      }).state;
  
      
  
      this.statusIds = statusId=='0'?'1,2,3,4,5,6,7,8,9,10,11':statusId;
  
      let durationFrom = null;
  let durationTo = null;

         // Handle date range from form
           if (
           this.appointmentsForm.value.appointmentDuration &&
           this.appointmentsForm.value.appointmentDuration.length === 2 &&
           this.appointmentsForm.value.appointmentDuration[0] &&
           this.appointmentsForm.value.appointmentDuration[1]
              ) {
                const fromDate = new Date(this.appointmentsForm.value.appointmentDuration[0]);
                const toDate = new Date(this.appointmentsForm.value.appointmentDuration[1]);
              
                // Start of the first day
                fromDate.setHours(0, 0, 0, 0);
                // End of the last day
                toDate.setHours(23, 59, 59, 999);
              
                // Format as local time without the Z (so backend won't shift it)
                const formatLocal = (d: Date) =>
                  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
                    d.getDate()
                  ).padStart(2, '0')}T${String(d.getHours()).padStart(2, '0')}:${String(
                    d.getMinutes()
                  ).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
              
                durationFrom = formatLocal(fromDate);
                durationTo = formatLocal(toDate);
              }

  
      const searchText = this.appointmentsForm.value.search?.trim() || '';
      this.params = {
        statusIds: this.statusIds,
        programId:19,
        FromDate: durationFrom,
        ToDate: durationTo,
        searchText:searchText,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
  
      this.getAllAppointments(this.params);
    }

    onFormSubmit() {
    // When Search button is clicked, use current active status to maintain button state
    this.onSearchAppointment(this.activeStatusId);
  }

  isActiveStatus(statusId: string): boolean {
    return this.activeStatusId === statusId;
  }


    // Optional: Add method to clear search
onClearSearch() {
  this.appointmentsForm.patchValue({
    search: ''
  });
    this.onSearchAppointment(this.activeStatusId);
}

// Optional: Add real-time search (debounced)
onSearchTextChange() {
  // Clear previous timeout
  if (this.searchTimeout) {
    clearTimeout(this.searchTimeout);
  }
  
  // Set new timeout for debounced search
  this.searchTimeout = setTimeout(() => {
    
    const currentStatus = this.statusIds || '0';
    this.onSearchAppointment(currentStatus);
  }, 500); 
}
  
    
  
    onSelectAllStatus() {
      this.selectAllStatues = !this.selectAllStatues;
    }
  
    
  
    getStatusName(id) {
      return id ? this.statusList.find((status) => status.id == id)?.state : '';
    }
  
    ExportTOExcel(): void {
      
      this.exportedAppointments = [];
      this.params['pageSize'] = this.totalItems;
      this.params['currentPage'] = 1;
  
      this.fetchAppointments(this.params).subscribe((res) => {
    const exportedAppointments = res?.data?.items || [];
  
        const data = exportedAppointments.map((appointment) => ({
           patientId: appointment.patientId,
           patientName: appointment.patientName,
           patientPhone: appointment.patientPhone,
           pspCode: appointment.pspCode,
           doctorName: appointment.doctorName,

           subscriptionDate:appointment.subscriptionDate 
                      ? this.datePipe.transform(appointment.subscriptionDate, "MMM d, y") : '',
           appointmentDate:appointment.creationDate 
                      ? this.datePipe.transform(appointment.creationDate, "MMM d, y") : '',
           appointmentTime: appointment.appointmentTime 
                  ? this.datePipe.transform(appointment.appointmentTime, "h:mm a") 
                  : '',
            patientStartTime: appointment.patientStartTime 
                  ? this.datePipe.transform(appointment.patientStartTime, "h:mm a") 
                  : '',
            doctorStartTime: appointment.doctorStartTime 
                  ? this.datePipe.transform(appointment.doctorStartTime, "h:mm a") 
                  : '',
           appointmentEndTime: appointment.appointmentEndTime 
                   ? this.datePipe.transform(appointment.appointmentEndTime, "h:mm a") 
        : '',           endBy: appointment.endBy,            
           isHavePrescription: appointment.isHavePrescription ? "Yes" : "No",
           status: this.getStatusName(appointment.statusId),
           callDuration: appointment.callDuration,
    }));
        const ws = XLSX.utils.json_to_sheet(data);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
        /* save to file */
        XLSX.writeFile(
          wb,
          `JourneyBeyondTheWeightReport.xlsx`
        );
      });
    }
  
    onAppointmentDetails(selectedItem): void {
      let item = selectedItem.selected[0];
      const initialState: ModalOptions<any> = {
        keyboard: true,
        class: 'modal-dialog-centered',
        initialState: {
          item,
        },
      };
  
      this.modalRef = this.modalService.show(
        AppointmentDetailsComponent,
        initialState
      );
    }
  
    onRefundHandler(event, item) {
      event.stopPropagation();
  
      const initialState: ModalOptions<any> = {
        keyboard: true,
        class: 'modal-dialog-centered modal-warning',
        initialState: {
          itemId: item.appointmentId,
        },
      };
  
      this.modalRef = this.modalService.show(RefundModalComponent, initialState);
  
      this.modalRef.content.event.subscribe((appointmentId) => {
        this.onRefundSubmit(appointmentId);
      });
    }
  
    onRefundSubmit(appointmentId) {
      this._AllAppoint.refund(appointmentId).subscribe((response) => {
        this.allAppointmentsArray.find(
          (app) => app.appointmentId === appointmentId
        ).refund = true;
        showNotification(
          'success',
          `The appointment has been refunded`,
          this.toastr
        );
        this.modalRef.hide();
      });
    }
  
    onReactiveHandler(event, item) {
      event.stopPropagation();
  
      const initialState: ModalOptions<any> = {
        keyboard: true,
        class: 'modal-dialog-centered modal-success',
        initialState: {
          itemId: item.appointmentId,
        },
      };
  
      this.modalRef = this.modalService.show(
        ReactiveModalComponent,
        initialState
      );
  
      this.modalRef.content.event.subscribe((appointmentId) => {
        this.onReactiveSubmit(appointmentId);
      });
    }
  
    onReactiveSubmit(appointmentId) {
      this._AllAppoint.reactivate(appointmentId).subscribe((response) => {
        this.allAppointmentsArray.find(
          (app) => app.appointmentId === appointmentId
        ).reactive = true;
        showNotification(
          'success',
          `The appointment has been reactivated`,
          this.toastr
        );
        this.modalRef.hide();
      });
    }
  
    onAddProblem(event, item): void {
      event.stopPropagation();
  
      if (item.hasProblem) {
        this.handleCloseProblem(item);
      } else {
        this.handleAddProblem(item);
      }
    }
  
    handleAddProblem(item) {
      const initialState: ModalOptions<any> = {
        keyboard: true,
        class: 'modal-dialog-centered',
        initialState: {
          item,
        },
      };
  
      this.modalRef = this.modalService.show(
        AddProplemModalComponent,
        initialState
      );
  
      this.modalRef.content.event.subscribe((proplemDescription) => {
        this.onAddProplemSubmit(item, item.appointmentId, proplemDescription);
      });
    }
  
    onAddProplemSubmit(appointment, appointmentId, proplemDescription) {
      this._AllAppoint
        .addProblem(appointmentId, 'false', '')
        .subscribe((response) => {
          this.allAppointmentsArray.find(
            (app) => app.appointmentId === appointmentId
          ).hasProblem = true;
  
          showNotification('success', `The problem has been added`, this.toastr);
          this.modalRef.hide();
        });
    }
  
    handleCloseProblem(item) {
      const initialState: ModalOptions<any> = {
        keyboard: true,
        class: 'modal-dialog-centered modal-danger',
        initialState: {
          itemId: item.appointmentId,
        },
      };
  
      this.modalRef = this.modalService.show(
        CloseProblemModalComponent,
        initialState
      );
  
      this.modalRef.content.event.subscribe((appointmentId) => {
        this.onCloseProblemSubmit(item, appointmentId);
      });
    }
  
    onCloseProblemSubmit(appointment, appointmentId) {
      this._AllAppoint
        .addProblem(appointmentId, 'true', '')
        .subscribe((response) => {
          this.allAppointmentsArray.find(
            (app) => app.appointmentId === appointmentId
          ).hasProblem = false;
  
          showNotification('success', `The problem has been closed`, this.toastr);
          this.modalRef.hide();
        });
    }

}
